export { default as selectLoanTypeModalBg } from './select-loan-type-modal-bg.png';
export { default as thankYouStepBg } from './thank-you-step-bg.png';
export { default as emptyMapPlaceholder } from './empty-map-placeholder.png';